import { React, useRef } from "react"
import Particle from "../components/Particle"
import SliderMainParticle from "../components/SliderMainParticle"
import FeatureBox from "../components/FeatureBox"
import CarouselCollection from "../menu/images/box_2.jpeg"
import CarouselCollection2 from "../menu/images/box_1.jpeg"
import CarouselCollection3 from "../menu/images/box_3.jpeg"
import { useNavigate } from "@reach/router"
import axios from "axios"
import swal from "sweetalert"
import { Form, Input, Checkbox, Select, Button } from "antd"
import { BaseUrl } from "../utils/config"
import Footer from "../components/footer"
import { createGlobalStyle } from "styled-components"
import "../../assets/home.css"
import "../../assets/custom.css"
import AuthorList from "../components/authorList"
import { useDispatch } from "react-redux"
import { updateUserDetailsRedux, setConnectedWallet } from "../../redux/actions"

const GlobalStyles = createGlobalStyle`
  header#myHeader .logo .d-block{
    display: none !important;
  }
  header#myHeader .logo .d-none{
    display: block !important;
  }
  .navbar .mainside a{
    background: #8364e2;
    &:hover{
      box-shadow: 2px 2px 20px 0px #8364e2;
    }
  }
  .item-dropdown{
    .dropdown{
      a{
        &:hover{
          background: #8364e2;
        }
      }
    }
  }
  .btn-main{
    background: #8364e2;
    &:hover{
      box-shadow: 2px 2px 20px 0px #8364e2;
    }
  }
  p.lead{
    color: #a2a2a2;
  }
  .navbar .navbar-item .lines{
    border-bottom: 2px solid #8364e2;
  }
  .jumbotron.no-bg{
    height: 100vh;
    overflow: hidden;
    background-repeat: repeat;
    backgroundSize: cover;
    background-position: bottom;
    background-repeat: no-repeat;
  }
  #tsparticles{
    top: 0;
  }
  .text-uppercase.color{
    color: #8364e2;
  }
  .de_count h3 {
    font-size: 36px;
    margin-bottom: 0px;
  }
  .de_count h5{
    font-size: 14px;
    font-weight: 500;
  }
  h2 {
    font-size: 30px;
  }
  .box-url{
    text-align: center;
    h4{
      font-size: 16px;
    }
  }
  .de_countdown{
    border: solid 2px #8364e2;
  }
  .author_list_pp, .author_list_pp i, 
  .nft_coll_pp i, .feature-box.style-3 i, 
  footer.footer-light #form_subscribe #btn-subscribe i, 
  #scroll-to-top div{
    background: #8364e2;
  }
  footer.footer-light .subfooter .social-icons span i{
    background: #403f83;
  }
  .author_list_pp:hover img{
    box-shadow: 0px 0px 0px 2px #8364e2;
  }
  .nft__item_action span{
    color: #8364e2;
  }
  .feature-box.style-3 i.wm{
    color: rgba(131,100,226, .1);
  }
  .nft_pic:hover{
    box-shadow:0px 0px 22px 5px #2d2a45;
  }
  @media only screen and (max-width: 1199px) {
    .navbar{
      
    }
    .navbar .menu-line, .navbar .menu-line1, .navbar .menu-line2{
      background: #fff;
    }
    .item-dropdown .dropdown a{
      color: #fff !important;
    }
  }
`

const HomePage = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const [form] = Form.useForm()
  const toLogin = item => {
    navigate(`/${item}`)
  }
  const myRef = useRef(null)
  const executeScroll = () => myRef.current.scrollIntoView()

  const onFinish = values => {
    const Fobj = {
      first_name: values.fName,
      last_name: values.lName,
      email: values.email,
      comment: values.comment
    }
    if (
      values.fName == null ||
      values.fName == "" ||
      values.lName == null ||
      values.email == null ||
      values.email == "" ||
      values.lName == "" ||
      values.comment == null ||
      values.comment == ""
    ) {
      swal({
        title: "",
        text: "Please enter the Credentials",
        icon: "error"
      })
    } else {
      axios
        .post(`${BaseUrl}/contactus`, Fobj)
        .then(response => {
          if (response) {
            // "Your Federal Account Created Successfully"
            // message.success(`Congratulations  Your Federal Account Created Successfully`,3)

            swal({
              title: "Success!",
              text: "Request submitted successfully, we will review and revert.",
              icon: "success"
            })
            // setTimeout(() => { navigate("/login"); }, 3000)
            form.resetFields()
          } else {
            swal({
              title: "Invalid Credentials",
              text: "Invalid credentials. Please try again.",
              icon: "error"
            })
          }
        })
        .catch(error => {
          if (error?.response?.status === 401) {
            dispatch(updateUserDetailsRedux({}))
            dispatch(setConnectedWallet(""))
            localStorage.clear()
            navigate("/login")
          } else {
            swal({
              title: error.message,
              text: "Please try to login",
              icon: "warning"
            })
          }
        })
    }
  }
  return (
    <div>
      <div className="containers no-bottom no-top">
        <section className="sec" style={{ display: "none" }}>
          <h1>
            Digital Mining and You. <br /> Its going to be phenomenal.
          </h1>

          <div className="icon ">
            <a onClick={executeScroll}>
              <img
                src="https://img.icons8.com/ios-filled/44/ffffff/down--v2.png"
                className="slide-bottom"
              />
            </a>
          </div>
        </section>

        <section
          className="bottom backgroundColordarkhome"
          id="bottom"
          ref={myRef}>
          <div className="container-fluid side-gap">
            <div className="row own-style">
              <div className=" mb-4">
                <div className="nft_pic large-height">
                  <div>
                    <span className="nft_pic_info">
                      <span className="nft_pic_title">Nesting</span>
                      <a href="/nest" className="take-a-look">
                        Click Here
                      </a>
                    </span>
                  </div>
                  <div className="nft_pic_wrap height-100">
                    <img
                      src={CarouselCollection}
                      className="lazy img-fluid"
                      alt=""
                    />
                  </div>
                </div>
              </div>
              <div className="mb-4">
                <div className="nft_pic little-big-nft large-height">
                  <div>
                    <span className="nft_pic_info">
                      <span className="nft_pic_title">
                        Pre miner <br /> Pending Payments
                      </span>
                      <a
                        onClick={() => toLogin("login")}
                        className="take-a-look">
                        Click Here
                      </a>
                    </span>
                  </div>
                  <div className="nft_pic_wrap height-100">
                    <img
                      src={CarouselCollection2}
                      className="lazy img-fluid"
                      alt=""
                    />
                  </div>
                </div>
              </div>
              <div className="mb-4">
                <div className="nft_pic large-height">
                  <div>
                    <span className="nft_pic_info">
                      <span className="nft_pic_title">Nitro Marketplace</span>
                      <span
                        className="nft_pic_title"
                        style={{ marginTop: "25px" }}>
                        Coming soon
                      </span>
                      {/* <a
                        onClick={() => toLogin("marketplace")}
                        className="take-a-look"
                      >
                        Click Here
                      </a> */}
                    </span>
                  </div>
                  <div className="nft_pic_wrap height-100">
                    <img
                      src={CarouselCollection3}
                      className="lazy img-fluid"
                      id="fit-full-image"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section
          className="bottom backgroundColordarkhome"
          id="contact-form-main-page"
          style={{
            paddingTop: "50px !important",
            backgroundSize: "cover"
          }}>
          <div className="container">
            <h1>Contact Us</h1>
            <div className="row mt-4">
              <div className="col-lg-6">
                <div
                  className="padding40 box-rounded mb30"
                  data-bgcolor="#292F45">
                  <address className="s1 text-center">
                    {/* <h4 className="fw300" >Or</h4> */}
                    <h2 className="fw300">reach out to us at</h2>
                    <h4 className="fw300">
                      {" "}
                      <a href="mailto:info@nitro.network">
                        {" "}
                        info@nitro.network
                      </a>
                    </h4>
                  </address>
                </div>
              </div>
              <div className="col-lg-6 cognito-form-contact-us">
                <Form
                  name="contactForm"
                  id="contact_form"
                  action=""
                  form={form}
                  autoComplete="off"
                  onFinish={onFinish}>
                  <div className="row">
                    <div className="col-md-6 mb-md-2">
                      <Form.Item
                        name="fName"
                        rules={[
                          {
                            required: true,
                            message: "First Name is required."
                          }
                        ]}>
                        <Input
                          type="text"
                          className="form-control"
                          placeholder="First name"
                        />
                      </Form.Item>
                    </div>
                    <div className="col-md-6 mb-md-2">
                      <Form.Item
                        name="lName"
                        rules={[
                          {
                            required: true,
                            message: "Last Name is required."
                          }
                        ]}>
                        <Input
                          type="text"
                          className="form-control"
                          placeholder="Last name"
                        />
                      </Form.Item>
                    </div>
                  </div>
                  <div className="form-group mb-md-2">
                    <Form.Item
                      name="email"
                      rules={[
                        {
                          type: "email",
                          message: "The email is not valid."
                        },
                        {
                          required: true,
                          message: "Email is required."
                        }
                      ]}>
                      <Input
                        type="text"
                        className="form-control"
                        id="inputEmail4"
                        placeholder="Email Address"
                      />
                    </Form.Item>
                  </div>
                  <div className="form-group">
                    <Form.Item
                      name="comment"
                      rules={[
                        {
                          required: true,
                          message: "Comment is required."
                        }
                      ]}>
                      <textarea
                        className="form-control my-0"
                        id="exampleFormControlTextarea1"
                        rows="3"
                        placeholder="Comment"></textarea>
                    </Form.Item>
                  </div>
                  <div className="text-center mt-4">
                    <button type="submit" className="btn-submit">
                      Submit
                    </button>
                  </div>
                </Form>

                {/* <!-- That Cognito -->
		<!-- <script src="https://www.cognitoforms.com/f/seamless.js" data-key="QnqbhO8ztkuM7m-OdAk53g" data-form="1"></script> --> */}
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* <Footer /> */}
    </div>
  )
}
export default HomePage
